import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as inquiriesService from "../../services/inquiry.services";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Breadcrums from "../../common/breadcrumbs";
import {
  formateDateWithMonth,
  handleServerValidations,
  TrimText,
} from "../../../../utils/commonfunction";
import CustomRangepicker from "../../common/rangepicker";
import Swal from "sweetalert2";
import { INQUIRY_STATUS, SWAL_SETTINGS, THEME_COLORS } from "../../../../utils/Constants";
import StatusFilter from "../../common/statusFilter";
import { Tooltip, Whisper, Placeholder } from "rsuite";
import * as $ from 'jquery';
import { useSearchParams } from "react-router-dom";
import { usePermission } from '../../../../utils/commonfunction';

const InquiryTable = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { can } = usePermission();
  const [list, setList] = useState([]);

  const [statsupdate, setStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [resetdate, setResetDate] = useState(false);
  const [searchParams] = useSearchParams();
  const [dateRange, setDateRange] = useState({});
  // const [search] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const [search, setSearch] = useState({
    ...(searchParams.get("status") ? { status: searchParams.get("status") } : {}),
  });
  console.log(search, 222);

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("sidebar_link_inquiries"), url: "" },
  ];
  const showInquiryFilterList = [
    { name: "list_heading_status", status__id: "" },
    { name: "new", status__id: "new" },
    { name: "responded", status__id: "responded" },
    { name: "in_progress", status__id: "in_progress" },
    { name: "closed", status__id: "closed" },
  ];

  const inquiryTypeFilterList = [
    { name: "All Types", status__id: "" },
    { name: "Contact", status__id: "contact" },
    { name: "Early Access", status__id: "early_access" },
  ];

  useEffect(() => {
    const getData = setTimeout(() => {

      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        if (dateRange.start) formData.append("start_date", dateRange.start);
        if (dateRange.end) formData.append("end_date", dateRange.end);
        inquiriesService
          .List(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            // setSerialNo(data.data.offset);
            setList(data && data.data && data.data.list ? data?.data?.list : []);
            // console.log("data.data.=====>", data.data);

            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }

    }, 300);
    return () => clearTimeout(getData)

  }, [
    location,
    statsupdate,
    sorting,
    search,
    globalsearch,
    itemperpage,
    params.pgno,
    dateRange,
  ]);


  const viewfunction = (row) => {
    navigate(
      `/admin/inquiries/view/${row._id}?page=1`
    );
  };

  const markResolve = (row, status) => {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("confirm_inquiry_status_text"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: t("btn_yes_resolve"),
      cancelButtonText: t("btn_cancel")
    }).then((result) => {
      if (result.isConfirmed) {
        const formdata = new FormData();

        formdata.append("_id", row._id);
        formdata.append("status", status)
        inquiriesService.resolveInquiry(formdata)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("deleteError");
          });
      }
    });
  }




  // sorting function start
  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };
  // sorting end

  // search or filter function

  const prepareSearch = (key, value) => {

    console.log('key---', key, value)
    const statusLabelMap = {
      "New": "new",
      "Responded": "responded",
      "In Progress": "in_progress",
      "Closed": "closed",
    };

    let sr;

    if (statusLabelMap[value]) {
      sr = { "status": statusLabelMap[value] };
    }

    else {
      sr = { ...search };
      if (String(value).length > 0) {
        sr[key] = value;
      } else {
        delete sr[key];
      }
    }

    if (value && typeof value === "string" && value.toLowerCase() === "status") {
      sr = {};
    }




    console.log('sr---', sr)
    setSearch(sr);
  };


  // search or filer end

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    setDateRange({});
    setResetDate(!resetdate);
    $("#defaultstatus")[0].selectedIndex = 0;
    $("#inquirytype")[0].selectedIndex = 0;
  };

  // const goToEdit = (row) => {
  //   navigate(
  //     `/admin/testimonial-management/testimonial/${params.pgno}/edit/${row._id}`
  //   );
  // };

  const Deletefunction = (row) => {

    Swal.fire({
      customClass: 'swal-wide',
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: t("btn_yes_delete"),
      cancelButtonText: t("btn_cancel")
    }).then((result) => {
      if (result.isConfirmed) {
        let id = row._id;
        const formdata = new FormData();
        formdata.append("_id", id);
        inquiriesService.Delete(formdata).then(response => {
          setStatusUpdate(!statsupdate)
          if (response.success) {
            Swal.fire({
              icon: 'success',
              text: response.message,
              ...SWAL_SETTINGS
            })

          } else {
            Swal.fire({
              icon: 'error',
              text: handleServerValidations(response),
              ...SWAL_SETTINGS
            })
          }
        }).catch((error) => {
          console.log("deleteError", error)
        });
      }
    })

  }

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">
                {t("sidebar_link_inquiries")}
              </h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      setDateRange(e && e.start ? e : {});
                    }}
                    resetdate={resetdate}
                  />
                </div>
                <div className="me-3">
                  <StatusFilter
                    data={showInquiryFilterList}
                    prepareSearch={prepareSearch}
                    selectedStatus={search?.status || ""}
                  />
                </div>
                <div className="me-3">
                  <select
                    id="inquirytype"
                    className="form-control select2"
                    onChange={(e) => prepareSearch("inquiry_type", e.target.value)}
                    value={search?.inquiry_type || ""}
                  >
                    {inquiryTypeFilterList.map((item, i) => (
                      <option key={i} value={item.status__id}>{item.name}</option>
                    ))}
                  </select>
                </div>

                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn ripple btn-main-primary signbtn"
                >
                  {t("btn_reset_filter")}
                </button>
              </div>
            </div>
            {loader ?
              <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7} />
              :
              <>
                <div className="table-responsive min-h-400">
                  <table className="table table-bordered border-t0 table table-bordered card-table border-top text-nowrap w-100 text-nowrap w-100">
                    <thead>
                      <tr>
                        <th className="position-relative select_head">
                          <span>{t("list_heading_sno")}</span>
                        </th>


                        <th className="status_head">{t("list_heading_status")}</th>
                        <th>
                          <div className="sorting_column">
                            <span>{t("list_heading_name")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="name"
                            />
                          </div>
                        </th>




                        <th>
                          <div className="sorting_column">
                            <span>{t("label_email")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="email"
                            />
                          </div>
                        </th>



                        {/* <th>
                          <div className="rating_head">
                            <span>{t("label_platform")}</span>
                          </div>
                        </th> */}
                        <th>
                          <div className="rating_head">
                            <span>Type</span>
                          </div>
                        </th>


                        <th>
                          <div className="rating_head">
                            <span>{t("label_subject")}</span>
                          </div>
                        </th>

                        {/* <th className="status_head">SUBSCRIBE</th> */}
                        <th className="created_head">
                          <div className="sorting_column">
                            <span>{t("label_inquiry_date")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              defaultSorting={defaultSorting}
                              column="createdAt"
                            />
                          </div>
                        </th>

                        {(can("/admin/inquiries/view") || can("/admin/inquiries/delete")) && (
                          <th className="action_head">{t("list_heading_action")}</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      <>
                        {list.length ? (
                          list.map((row, i) => {
                            return (
                              <tr
                                key={i}
                              >

                                <td>
                                  {row ? ((page - 1) * itemperpage) + i + 1 : null}
                                </td>


                                <td>
                                  <div className="btn-group mlAction">
                                    <Whisper
                                      placement="top"
                                      controlId="control-id-hover"
                                      trigger="hover"
                                      speaker={
                                        <Tooltip>
                                          {t("label_change_inquiry_status")}
                                        </Tooltip>
                                      }
                                    >
                                      <span className="dropdown-toggle no-after" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i
                                          className="ri-settings-5-fill me-1"
                                          style={{
                                            color: "#000000",
                                            fontSize: "18px",
                                            cursor: "pointer",
                                            marginLeft: "6px",
                                          }}
                                        ></i>
                                      </span>
                                    </Whisper>

                                    <ul className="dropdown-menu">
                                      <li>
                                        <button
                                          className="dropdown-item"
                                          onClick={() => {
                                            markResolve(row, INQUIRY_STATUS.NEW);
                                          }}
                                        >
                                          {t("btn_new")}
                                        </button>
                                      </li>

                                      <li>
                                        <button
                                          className="dropdown-item"
                                          onClick={() => {
                                            markResolve(row, INQUIRY_STATUS.IN_PROGRESS);
                                          }}
                                        >
                                          {t("btn_in_progress")}
                                        </button>
                                      </li>


                                      <li>
                                        <button
                                          className="dropdown-item"
                                          onClick={() => {
                                            markResolve(row, INQUIRY_STATUS.RESPONDED);
                                          }}
                                        >
                                          {t("btn_responded")}
                                        </button>
                                      </li>


                                      <li>
                                        <button
                                          className="dropdown-item"
                                          onClick={() => {
                                            markResolve(row, INQUIRY_STATUS.CLOSED);
                                          }}
                                        >
                                          {t("btn_closed")}
                                        </button>
                                      </li>




                                    </ul>
                                  </div>
                                  {(() => {
                                    if (row.status === INQUIRY_STATUS.IN_PROGRESS) {
                                      return <span className="badge badge-pill badge-primary-light">{t(row.status)}</span>
                                    } else if (row.status === INQUIRY_STATUS.RESPONDED) {
                                      return <span className="badge badge-pill badge-info-light">{t(row.status)}</span>
                                    } else if (row.status === INQUIRY_STATUS.CLOSED) {
                                      return <span className="badge badge-pill badge-success-light">{t(row.status)}</span>
                                    } else {
                                      return <span className="badge badge-pill badge-danger-light">{t(row.status)}</span>
                                    }
                                  })()}
                                </td>

                                <td>
                                  {row?.name ? (
                                    <div className="d-flex">
                                      {row?.name ? TrimText(row.name, 50) : "N/A"}
                                    </div>
                                  ) : (
                                    <div className="d-flex">"N/A"</div>
                                  )}
                                </td>




                                <td>
                                  {row?.email ? (
                                    <div className="d-flex">{TrimText(row.email, 50)}</div>
                                  ) : (
                                    <div className="d-flex">N/A</div>
                                  )}
                                </td>



                                {/* <td>
                                  {row?.role ? (
                                    <div className="d-flex">{t(row.role)}</div>
                                  ) : (
                                    <div className="d-flex">N/A</div>
                                  )}
                                </td> */}
                                <td>
                                  {row?.inquiry_type === 'early_access' ? (
                                    <span className="badge badge-pill badge-warning-light">Early Access</span>
                                  ) : (
                                    <span className="badge badge-pill badge-primary-light">Contact</span>
                                  )}
                                </td>

                                <td>
                                  {row?.subject ? (
                                    <div className="d-flex">{TrimText(row.subject, 35)}</div>
                                  ) : (
                                    <div className="d-flex">N/A</div>
                                  )}
                                </td>

                                <td>
                                  {row.createdAt
                                    ? formateDateWithMonth(row.createdAt)
                                    : "N/A"}
                                </td>


                                {(can("/admin/inquiries/view") || can("/admin/inquiries/delete")) && (
                                  <td>
                                    <div className="btn-toolbar table-actions" role="toolbar" aria-label="Toolbar with button groups">
                                      <div className="btn-group btn-group-sm" role="group" aria-label="Second group">
                                        {can("/admin/inquiries/view") && (
                                          <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: 'bold' }}>View</Tooltip>}>
                                            <button type="button" className="btn view" onClick={() => { viewfunction(row); }}>
                                              <i className="ri-eye-fill"></i>
                                            </button>
                                          </Whisper>
                                        )}
                                        {can("/admin/inquiries/delete") && (
                                          <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: 'bold' }}>Delete</Tooltip>}>
                                            <button type="button" className="btn delete" onClick={() => { Deletefunction(row) }}>
                                              <i className="ri-delete-bin-6-fill"></i>
                                            </button>
                                          </Whisper>
                                        )}
                                      </div>
                                    </div>
                                  </td>
                                )}
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={10} className="text-center">
                              {t("msg_no_records")}
                            </td>
                          </tr>
                        )}
                      </>
                    </tbody>
                  </table>
                </div>
                <div
                  className=""
                  id="example1_info"
                  role="status"
                  aria-live="polite"
                >
                  <b>
                    {t("msg_total_records")} : {datalength ? datalength : "0"}
                  </b>
                </div>
                {datalength && datalength > 0 ? (
                  <CustomPagination
                    datalength={datalength}
                    itemperpage={itemperpage}
                    currentPage={page}
                    setPage={setPage}
                    pageRoute={[
                      {
                        name: "Reataurant",
                        path: "/admin/inquiries/list",
                      },
                    ]}
                  />
                ) : (
                  ""
                )}
              </>
            }
          </div>
        </div>
      </div>

    </>
  );
};

export default InquiryTable;
